export default "/assets/images/app-showcase-02-sm.jpg?9b431022bd07d581d6b6fb41bbc95d59";